import { useGetTasksQuery } from "./tasksApiSlice"
import Task from "./Task"
import useAuth from "../../hooks/useAuth"
import PulseLoader from 'react-spinners/PulseLoader'
import { faAdd } from "@fortawesome/free-solid-svg-icons"
import { Link, useParams } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
const TasksList = ({active, status, q , selected, setSelected}) => {
    const {groupId, type} = useParams()
    const {  isTeacher, isAdmin } = useAuth()
    const {
        data: tasks,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetTasksQuery('tasksList', {
        // pollingInterval: 15000,
        // refetchOnFocus: true,
        refetchOnMountOrArgChange: false
    })




    let content

    if (isLoading) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }

    if (isSuccess ) {
        const { ids, entities } = tasks
       
        let filteredIds = []
        if((groupId!=='0')|| active || status !=0 || q!==''){
            filteredIds=[...ids].filter(taskId =>{
                const task =  entities[taskId]
             return ((groupId==='0' || task.group === groupId ) &&
                    (!active ||  Date.parse(task.toDate) - Date.parse(new Date())>0 ) &&
                    (status ==0 ||( 
                                 (status ==1 && task.doneActions ===task.numActions  )
                                ||(status ==2 && task.doneActions < task.numActions  )
                                ||(status ==3 && task.gradeActions === task.numActions  )
                                || (status ==4 && task.gradeActions < task.numActions  )
                                ) ) &&
                     (q==='' ||((task.title.indexOf(q) >-1)||(task.body.indexOf(q) >-1) )))

            })
        }else
            {
                filteredIds = [...ids]
            }
        let addButtn= null
        if(isAdmin || isTeacher){
        addButtn = (
        <Link to={`/${type}/${groupId}/tasks/new`}>
 <FontAwesomeIcon icon={faAdd} />הוספת משימה
        </Link>
        
      )
        }

        const tableContent = ids?.length && filteredIds.map(taskId => <Task key={taskId} taskId={taskId} selected={selected} setSelected={setSelected}  />)

        content = (
            <>
            {addButtn}
            <table className={`table table--tasks ${(isAdmin || isTeacher)&& "table--tasks--admin"} `}>
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th task__title">משימה</th>
                        <th scope="col" className="table__th task__body">תוכן</th>
                        <th scope="col" className="table__th task__dates">זמן נותר</th>
                        <th scope="col" className="table__th task_student task__done"> בוצע</th>
                        <th scope="col" className="table__th task_student task__dates"> ציון </th>
                        <th scope="col" className="table__th "> יחס</th>
                        <th scope="col" className="table__th task__actions"> פעולות</th>
                        <th scope="col" className="table__th task__edit">#</th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent}
                </tbody>
            </table>
            </>
        )
    }

    return content
}
export default TasksList